import { createReducer } from '@reduxjs/toolkit';

import { merchantGroupsActions } from './actions';
import { IMerchantGroup } from './types';

const initialState: { entities: IMerchantGroup[]; entity: IMerchantGroup[]; totalCount: number } = {
  entities: [],
  entity: [],
  totalCount: 0,
};

export const merchantGroupsReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(merchantGroupsActions.getMany.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.entities = action.payload.content;
      state.totalCount = action.payload.totalElements;
    })
    .addCase(merchantGroupsActions.getDetailsById.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.entity = action.payload.content;
    }),
);
